import { fetchApi } from '@/helpers/fetchApi.js'

export default {
  state: {
    locations: [],
    locations_loading: false,
  },
  getters: {
    locations: (state) => state.locations,
  },
  mutations: {
    setLocations(state, locations) {
      state.locations = locations
    },
    setLocationsLoading(state, value) {
      state.locations_loading = value
    },
  },
  actions: {
    async fetchLocation(_, id) {
      return new Promise((resolve, reject) => {
        fetchApi(`locations/${id}`)
          .then(resolve)
          .catch(() => reject(`Unable to fetch location with id: ${id}.`))
      })
    },
    async emptyLocations({ commit }) {
      commit('setLocations', [])
    },
    async fetchLocations({ state, commit }) {
      if (state.locations_loading) return

      commit('setLocationsLoading', true)

      try {
        const locations = await fetchApi('locations')

        commit('setLocations', locations)
      } finally {
        commit('setLocationsLoading', false)
      }
    },
    async loadLocations({ state, dispatch }) {
      if (!state.locations.length) {
        await dispatch('fetchLocations')
      }
    },
  },
}
